import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '全部影片', href: '/category/all' },
  { label: '热门排行', href: '/category/all?sort=hot' },
  { label: '影视资讯', href: '/category/all' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/50'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16 max-w-[1400px] mx-auto">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-50 no-underline whitespace-nowrap"
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-movie-2-line text-primary-500 text-2xl"></i>
            </div>
            <span className="font-heading text-xl tracking-wide">窝窝影院</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm whitespace-nowrap transition-colors hover:text-primary-400 ${
                  location.pathname === link.href
                    ? 'text-primary-400'
                    : 'text-foreground-300'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-300 cursor-pointer"
            aria-label="打开菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200/50 bg-background-50/95 backdrop-blur-md">
            <div className="flex flex-col py-3 px-4 gap-2 max-w-[1400px] mx-auto">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`text-sm py-2 px-3 rounded-md whitespace-nowrap transition-colors ${
                    location.pathname === link.href
                      ? 'text-primary-400 bg-primary-500/10'
                      : 'text-foreground-300 hover:text-primary-400'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}